/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import i18n from "data/lang/i18n";
import dayjs from "dayjs";
import { NavLink } from "react-router-dom";
import Config from "data/config";

const renderLinkCell = (params, tab, value) => {
    const row = params?.row;
    const content_type = row?.content_type;
    const content_guid = row?.content_guid;
    // TODO: make the entire cell clickable (maybe multiple cells)
    
    return (
        <NavLink 
            className="column-link"
            to={`/forms/${content_type}/${tab}/${content_guid}`}
        >
            {value}
        </NavLink>
    );
};

export const columnsConfig = [
    {
        field: "content_name",
        headerName: i18n.t("commons.title"),
        cellClassName: "column columnTitle",
        width: 350,
        renderCell: (params) => renderLinkCell(params, "build", params?.row?.content_name),
    },
    {
        field: "content_type",
        headerName: i18n.t("commons.type"),
        cellClassName: "column columnType",
        renderCell: (params) => renderLinkCell(params, "build", params?.row?.content_type),
    },
    {
        field: "content_status",
        headerName: i18n.t("commons.status"),
        cellClassName: "column contentStatus",
        renderCell: (params) => renderLinkCell(params, "build", params?.row?.content_status),
    },
    {
        field: "content_updated_at",
        headerName: i18n.t("commons.lastUpdated"),
        cellClassName: "column",
        valueGetter: (params) => params?.row?.content_updated_at,
        renderCell: (params) => renderLinkCell(params, "build", formatDate(params?.row?.content_updated_at)),
        width: 200,
    },
    {
        field: "content_reuses",
        headerName: i18n.t("commons.uses"),
        cellClassName: "column",
        renderCell: (params) => renderLinkCell(params, "build", params?.row?.content_reuses),
    },
    {
        field: "content_responses",
        align: "left",
        isSort: true,
        headerName: i18n.t("commons.responses"),
        cellClassName: "column contentResponses",
        renderCell: (params) => renderLinkCell(params, "results", params?.row?.content_response_count),
    },
    {
        field: "content_last_response",
        headerName: i18n.t("commons.lastResponse"),
        cellClassName: "column",
        width: 200,
        valueGetter: (params) => params?.row?.content_last_response,
        renderCell: (params) => renderLinkCell(params, "build", formatDate(params?.row?.content_last_response)),
    },
];

const formatDate = (date) => (date ?
    dayjs.utc(date).local().format(Config.dates.general_long)
    : "---");

/**
 * @param {import('./form-builder/form-tabs/responses/form.types').FormResponse[]} data
 * @param {'forms' | 'results'} page
 */
export const transformRows = (data, page) => {
    const rows = [];

    if (data) {
        for (const dataRow of data) {
            let row = { id: dataRow.guid };
            // console.log("dataRow::", dataRow );
            Object.keys(dataRow)
                .filter((item) => item !== "id")
                .forEach((item) => {
                    row = {
                        ...row,
                        [`content_${item}`]: dataRow[item]
                    };

                    if (page === "forms") {
                        row = {
                            ...row,
                            content_reuses: dataRow?.reuse_count || 0,
                            content_responses: dataRow?.response_count || 0,
                        };
                    }
                });

            rows.push(row);
        }
    }

    return rows;
};
